import { render, staticRenderFns } from "./AudioPlayer.vue?vue&type=template&id=0eb2a4d7&"
import script from "./AudioPlayer.vue?vue&type=script&lang=ts&"
export * from "./AudioPlayer.vue?vue&type=script&lang=ts&"
import style0 from "./AudioPlayer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\koen\\workspace\\cf2\\src\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0eb2a4d7')) {
      api.createRecord('0eb2a4d7', component.options)
    } else {
      api.reload('0eb2a4d7', component.options)
    }
    module.hot.accept("./AudioPlayer.vue?vue&type=template&id=0eb2a4d7&", function () {
      api.rerender('0eb2a4d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AudioPlayer.vue"
export default component.exports